import moment from 'moment';

import * as types from '../constants/actionTypes';
import { scriptVersion, buildNumber } from '../constants/config';
import { hashHistory } from 'react-router/lib';
import { resourceApi } from '../utils/fetchUtil';
import { getUserProfile, refreshDeviceToken, updateFcmToken, sessionExpired, getTokenTimestamp, 
  tryGetNewAccessToken, 
  updateUserRefreshToken  } from './authActions'; 

import { initializeHub, startConnection } from './signalrActions'; 

import { 
  loadMessages, loadMessage
  
} from './messageActions';

import { getToken, setToken } from '../utils/tokenUtil';


export function addLogEvent(log) {
  return {
    type: types.ADD_LOG_EVENT,
    log: log
  };
}

export function showGlobalMessage(message, isError) {
    return {
        type: types.SHOW_GLOBAL_MESSAGE,
        message: message,
        isError: isError
    };
}

export function hideGlobalMessage() {
    return {
        type: types.CLOSE_GLOBAL_MESSAGE
    };
}

export function showGlobalSpinner() {
    return {
        type: types.SHOW_SPINNER
    };
}

export function hideGlobalSpinner() {
    return {
        type: types.HIDE_SPINNER
    };
}



export function setTokenRefreshTimer(callback) {
    // ifvisible.on("idle", function(){
    //     //checkIfUserIsActive(callback);
    // });
    // window.tokenCheckInterval = window.setInterval(function(){ 
    //     checkIfUserIsActive(callback); 
    // }, 60000);   // check every minute
 
    window.tokenCheckInterval = window.setInterval(function(){ 
        checkIfUserIsActive(callback); 
    }, 600000);   // check every 10 minutes

    //(15 * 60000));  
}


function checkIfUserIsActive(callback) {

    //var tts = getTokenTimestamp();
    
    //if(tts) { // the initial rollout will ened to check for availability, folks wont have in browserHistory. 
    //    if(new Date() > Date.parse(tts)) {
    
            // if(!ifvisible.now('active')){
            //     window.clearInterval(window.tokenCheckInterval);
            //     callback();
            // }
    
            //if(ifvisible.now('active')){

                console.log('try get access token');
                tryGetNewAccessToken().then((access_token) => {
                    if(access_token) {
    
                        console.log('setToken');
                        setToken(access_token);
                    }
                    else{
                        console.log('clearInterval');
                        window.clearInterval(window.tokenCheckInterval);
                        callback();
                    }
                });
            // }
            // else{
            //     console.log('clearInterval');
            //     window.clearInterval(window.tokenCheckInterval);
            //     callback();
            // }
        //}
   // }
}





export function changeWidthAndHeight(height, width) {
  return {
    type: types.CHANGE_WIDTH_AND_HEIGHT,
    height,
    width,
  };
}

export function recievePosition(position) {
  return {
    type: types.RECIEVE_POSITION,
    position: position
  };
}

export function changeTab(tab) {
  return {
    type: types.CHANGE_TAB,
    tab: tab
  }
}

export function setPageName(name) {
  return {
    type: types.CHANGE_PAGE_NAME,
    name: name
  }
}

export function inactivateApp() {
  return {
    type: types.INACTIVATE_APP
  }
}


export function initApp(withAuth) {

  //setTokenRefreshTimer(sessionExpired);

  return (dispatch, getState) => {

    dispatch(loadMessages());

    var messaging = getState().thisApp.messaging;
    if(messaging.showMessage){
      dispatch(loadMessage(messaging.message));
    }

    // this call must be in the init in case of a refresh.
    dispatch(getUserProfile());
    
    dispatch(initializeHub());
        
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i      
    .test(navigator.userAgent);
    
    // if (isMobile) {
    //   document.body.style.overflow = 'hidden';
    // }

    dispatch(registerCordovaEvents());
  };
}

export function submitVersions(){

  let config = {
    method:'post',
    url:'member/versions',
    data:{
      ShellVersion: '0.0.0',
      ScriptVersion:buildNumber,
      Platform:'unknown'
    }
  }
  
  if(window.cordova && window.cordova.platformId){
    config.data.Platform = window.cordova.platformId.toLowerCase();
  } else if (window.device && window.device.platform){
    config.data.Platform = window.device.platform.toLowerCase();
  }
  
  if(window.AppVersion){
    window.AppVersion.getInfo((v)=>{
      config.data.ShellVersion = v.version ? v.version : config.data.ShellVersion      
      resourceApi(config)
      .then(r => console.log('Version info updated.'))
      .catch(e => console.log('Failed to updated version info.'))
    }, (e)=>{console.log("Error Retrieving Version")})
  }
  else {
      resourceApi(config)
      .then(r => console.log('Version info updated without Shell Info.'))
      .catch(e => console.log('Failed to updated version info.'))
  }
}



function registerCordovaEvents() {

  return (dispatch, getState) => {

    if(window.FCMPlugin) {

      if(window.FCMPlugin.onTokenRefresh) {
        //Note that this callback will be fired everytime a new token is generated, including the first time.
        window.FCMPlugin.onTokenRefresh(function(token){
            dispatch(updateFcmToken(token));
        });
      } 

      if(window.FCMPlugin.onNotification) {

        window.FCMPlugin.onNotification(function(data){

              // when would we do here that we don't do in the resume() event?

              // if(data.wasTapped){
              //   //Notification was received on device tray and tapped by the user. 
              //   alert( JSON.stringify(data) );
              // }else{
              //   //Notification was received in foreground. Maybe the user needs to be notified. 
              //   alert( JSON.stringify(data) );
              // }
              //window.checkForNewMessages();
          });
      }
    }

    if(window.FCM){
      window.FCM.onTokenRefresh(function(token){
        dispatch(updateFcmToken(token));
    });
      // window.FCM.onNotification().then(function(data){ });
    }
  }
}


// this method may be better suited in the users actions file. 
export function getUserLocation() {

  return dispatch => {


    if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition(
                function (pos) {
                    let config = {
                      method: 'post',
                      url: `member/saveLocation`,
                      data: {
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude
                      }
                    };
                    
                    resourceApi(config); 

                    dispatch(recievePosition(pos));
                },
                function(error) {
                    
                    console.log(error);
                },
                {
                    maximumAge: 60000,
                    timeout: 5000,
                    enableHighAccuracy: true
                }
            );
            
        }
  };
}



export function checkForScriptUpdates() {

  return dispatch => {
    
     let config = {
      method: 'get',
      url: `application/mobilescriptversion`
    };
    
      resourceApi(config, dispatch, false) 
        .then(function (response) {
            console.log(response);
            
            if(scriptVersion != response.data.Value.toString()) {
                dispatch(inactivateApp());
                hashHistory.push('/inactive');
            }
            else{
              hashHistory.push('/home');
            }
            
        })
        .catch(function (error) {
            console.log(error);
            hashHistory.push('/home');
        });
  }
}

export function fireInAppBrowserPlugin(url) {
    // https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-device/index.html
    // the safe bet is to use system which works on android but opens a safari window on new iOS
    // unfortunately the _blank option does not work in older versions of iOS

    //https://www.theiphonewiki.com/wiki/Models
    //https://www.javatpoint.com/android-versions

    var arg1 = "_system";   

//need to continue using _system for tel: links
//need to continue using _system for mailto: links

    if(window.device && !url.includes("tel:") && !url.includes("mailto:")){
      if(window.device.platform.toLowerCase() === 'ios'){
        var versionDouble = parseFloat(window.device.version);

        if(versionDouble >= 13.1) { 
          // _blank will not work for IAB if os version older than 12 
          arg1 = "_blank"; 
        }
      }
      // else if(window.device.platform.toLowerCase() === 'android'){
      //   arg1 = "_blank"; 
      //   // at this point nothing works on Android except for _system.
      //   // unlike iOS, android doesnt have a built in PDF viewer.
      //   //https://stackoverflow.com/questions/26304729/not-able-to-launch-a-pdf-file-in-inappbrowser-in-android
      // }
    }

    window.open(url, arg1, "location=no");
}



// export function checkForAppUpdates() {

//     return dispatch => {
    
//         fetcher.get(`application/mobileappversion`)
//           .then(function (response) {
//               console.log(response);

//               if(appVersion !== response.data.Value) {
//                 dispatch(alertToReDownload());
//               }
            
//           })
//           .catch(function (error) {
//               console.log(error);
//           });
//     }

// }


// function alertToReDownload() {
//     return {
//       type: ALERT_REDOWNLOAD,
//       globalMessage: "We've made some enhancements! Please visit the app store and update the app."
//     }
// }


export function closeGlobalMessage() {
  return {
    type: types.CLOSE_GLOBAL_MESSAGE
  }
}



// WEBPACK FOOTER //
// ./src/actions/environmentActions.js